import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IDepartment } from '../models/department';
import { EEopTemplates } from '../models/eop_types.enum';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
    constructor(private http: HttpClient) {}

    getDepartments(eopTemplateId: EEopTemplates, orgType?: string, teamType?: string): Observable<{has_error: boolean, message: string, data: IDepartment[]}> {
      const url = environment.apiBaseUrl + endpoints.departments.replace(':eopTemplateId', eopTemplateId.toString());
      let params = new HttpParams();
      if (orgType) {
        params = params.set('org_type', orgType);
      }
      if (teamType) {
        params = params.set('team_type_id', teamType);
      }
      
      return this.http.get<{has_error: boolean, message: string, data: IDepartment[]}>(url, { params }).pipe(
        // Positions are shown in dropdowns and lists across the app, so sort once here
        // rather than in every consumer.
        map(response => ({
          ...response,
          data: response.data
            ? [...response.data].sort((a, b) => a.department.localeCompare(b.department))
            : response.data
        })),
        catchError(this.handleError)
      );
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
      let errorMessage = 'An unknown error occurred!';
      
      if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
        errorMessage = `Client-side error: ${error.error.message}`;
      } else {
        errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
      }
      console.error(errorMessage);
      return throwError(() => new Error("Cannot retrieve data from server. Please try again."));
    }

    

}